import { BasePickupLocation, ExtendedPickupLocation } from 'gql/types';

export default (
  isAdmin: boolean,
  pickupLocation?: BasePickupLocation &
    Pick<ExtendedPickupLocation, 'shortName' | 'priority'>
): string => {
  if (!pickupLocation) {
    return '';
  }

  const {
    zipCode,
    city,
    streetName,
    buildingNumber,
    shortName,
  } = pickupLocation;

  if (isAdmin && shortName) {
    return shortName;
  }

  const hasAdditionalData = streetName || buildingNumber;

  const additionalText = hasAdditionalData
    ? `, ul. ${streetName}${buildingNumber ? ' ' + buildingNumber : ''}`
    : '';

  return `${zipCode ? zipCode + ' ' : ''}${city}${additionalText}`;
};
